import { RadioBooleanFilterOperation } from '@hotjar/global-filters';
import { QueryKeyEnum } from '@hotjar/global-filters/src/domains/global-filters/model/QueryFormat';
import type { RadioBooleanFilterValue } from '@hotjar/global-filters';
import { UserAttributeQueryKind, UserAttributesFilter } from './UserAttributeFilters';

import type {
  UserAttributeClauseNameless,
  UserAttributeWithKindType,
} from './UserAttributeFilters';

export const mapBooleanUserAttribute = (
  filter: RadioBooleanFilterValue | undefined,
): UserAttributeClauseNameless => {
  const type: UserAttributeWithKindType = `${QueryKeyEnum.user_attributes}.${UserAttributeQueryKind.BOOL}`;
  switch (filter?.operation) {
    case RadioBooleanFilterOperation.IS_TRUE:
      return { type, operation: UserAttributesFilter.EQUALS, value: true };
    case RadioBooleanFilterOperation.IS_FALSE:
      return { type, operation: UserAttributesFilter.EQUALS, value: false };
    case RadioBooleanFilterOperation.IS_UNKNOWN:
      return { type, operation: UserAttributesFilter.IS_UNKNOWN };
    case RadioBooleanFilterOperation.HAS_ANY_VALUE:
    default:
      return { type, operation: UserAttributesFilter.HAS_ANY_VALUE };
  }
};
